module.exports = __webpack_public_path__ + "static/media/PricingDQWorkspace0.b149eb86.png";